<template>
    <span class="px-3 py-1 rounded-full shadow" :class="classes">{{ status }}</span>
</template>

<script>
    export default {
        computed: {
            status() {
                if (this.params.value) {
                    return 'Inactive';
                }

                return 'Active';
            },
            classes() {
                if (this.params.value) {
                    return 'bg-red-200 text-red-700';
                }

                return 'bg-green-200 text-green-700';
            }
        }
    }
</script>